import { m } from "framer-motion";
// @mui
import { styled } from "@mui/material/styles";
//
import Logo from "./Logo";
import palette from "../theme/palette";

// ----------------------------------------------------------------------

const StyledRoot = styled("div")(({ themeMode }) => ({
    right: 0,
    bottom: 0,
    zIndex: 9998,
    width: "100%",
    height: "100%",
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: palette(themeMode).background.default,
}));

// ----------------------------------------------------------------------

export default function LoadingScreen() {

    return (
        <>
            <StyledRoot
                themeMode={"light"}
            >

                <>
                    <m.div
                        animate={{
                            scale: [
                                1, 1, 0.999, 0.998, 0.997, 0.995, 0.992, 0.99, 0.987, 0.99,
                                0.992, 0.995, 0.997, 0.998, 0.999, 1, 1,
                            ],
                            opacity: [
                                1, 0.9, 0.8, 0.7, 0.6, 0.5, 0.4, 0.35, 0.4, 0.5, 0.6, 0.7,
                                0.8, 0.9, 1,
                            ],
                        }}
                        transition={{
                            duration: 2,
                            ease: "easeInOut",
                            repeatDelay: 0,
                            repeat: Infinity,
                        }}
                    >
                        <Logo disabledLink sx={{ width: 300, height: 300 }} isDark />
                    </m.div>

                </>
            </StyledRoot>
        </>
    );
}
